import * as z from "zod";

const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
const reqStrSchema = z.string().min(1, { message: "این فیلد الزامی است" });
const linkSchema = z.string().refine(
  (val) => {
    const regex = /^[a-zA-Z0-9\-]+[a-zA-Z0-9]$/;
    return regex.test(val);
  },
  {
    message:
      "این فیلد می تواند شامل حروف انگلیسی،اعداد و خط تیره باشد ولی نمی‌تواند با خط تیره پایان یابد",
  }
);
const reqNumSchema = z
  .number()
  .refine((val) => val !== 0, { message: "این فیلد الزامی است" });

const datereqStrSchema = z
  .string()
  .transform((val) => (val == null ? "" : val));

const dateSchema = datereqStrSchema
  .refine((val) => val !== "", {
    message: "این فیلد الزامی است",
  })
  .refine((val) => dateRegex.test(val), {
    message: "فرمت تاریخ نامعتبر است.",
  });

const passwordSchema = z
  .string()
  .min(8, { message: "رمز عبور حدید می بایست حداقل 8 کاراکتر باشد" })
  .max(20, { message: "رمز عبور حدید می بایست حداکثر20 کاراکتر باشد" })
  .refine((password) => /[A-Z]/.test(password), {
    message: "رمز عبور حدید می بایست حداقل دارای یک حرف بزرگ انگلیسی باشد",
  })
  .refine((password) => /[a-z]/.test(password), {
    message: "رمز عبور حدید می بایست حداقل دارای یک حرف کوچک انگلیسی باشد",
  })
  .refine((password) => /[0-9]/.test(password), {
    message: "رمز عبور جدید می بایست حداقل دارای یک عدد باشد",
  })
  .refine((password) => /^[^\u0600-\u06FF\s]+$/.test(password), {
    message: "رمز عبور جدید نمی تواند شامل حروف غیر انگلیسی  باشد      ",
  })
  .refine((password) => /[!@#$%^&*]/.test(password), {
    message: "رمز عبور حدید می بایست حداقل دارای یک کاراکتر خاص باشد",
  });

export const loginSchema = z.object({
  username: z
    .string()
    .min(1, { message: "این فیلد الزامی است" })
    .regex(/^09\d{9}$/, {
      message: "فرمت شماره همراه اشتباه است",
    })
    .length(11, " شماره تلفن باید 11 رقمی باشد"),
  password: z.string().min(1, { message: "این فیلد الزامی است" }),
});

export const newPasswordSchema = z
  .object({
    new_password: passwordSchema,
    new_password2: passwordSchema,
  })
  .superRefine(({ new_password, new_password2 }, ctx) => {
    if (new_password !== new_password2) {
      ctx.addIssue({
        code: "custom",
        message: "تکرار رمز عبور با رمز عبور جدید مطابقت ندارد.",
        path: ["new_password2"],
      });
    }
  });
export const oldPasswordSchema = z.object({
  old_password: z.string().min(1, { message: "این فیلد الزامی است" }),
});
export const changeOldPasswordSchema = z.object({
  otp: z.string().length(6, { message: "این فیلد 6 رقمی است" }),
  new_password: passwordSchema,
  new_password2: passwordSchema,
});
export const FixedPasswordSchema = z.object({
  otp: z.string().length(6, { message: "این فیلد 6 رقمی است" }),
  fixed_password: z
    .string()
    .min(10, { message: "این فیلد می بایست حداقل 10  باشد" }),
});

export const externalWithdrawsSchema = z.object({
  amount: z.string().min(1, { message: "این فیلد الزامی است" }),
  iban_nickname: z.string(),
  iban: z.string().length(24, { message: "شماره شبا باید 24 رقمی باشد" }),
  description: z.string(),
});
export const internalWithdrawsSchema = z.object({
  amount: z.string().min(1, { message: "این فیلد الزامی است" }),
  mobile: z.string().length(11, { message: "شماره تلفن باید 11 رقمی باشد" }),
  description: z.string(),
});

export const IbanNoteSchema = z.object({
  iban_nickname: z.string(),
  iban: z.string().length(24, { message: "شماره شبا باید 24 رقمی باشد" }),
});
